<template>
  <div class="layout">
    <div class="menu">
      <Menu topIndex="5"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="labelManage" leftIndex="0"></LeftSideBar>
    </div>
    <div id="deptContentBox" class="base-content">
      <!-- 上方按钮 -->
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="newTag()"
          >新增</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          @click="editTag()"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-close"
          @click="deletePre()"
          >删除</el-button
        >
      </div>
      <!-- 上方按钮end -->
      <!-- 搜索 -->
      <div id="searchBox">
        <el-form label-width="80px">
          <el-form-item label="标签名称">
            <el-input placeholder="请输入标签名称"></el-input>
          </el-form-item>
          <el-form-item label="标签">
            <el-input placeholder="请输入编码"></el-input>
          </el-form-item>
          <el-form-item label-width="0px">
            <el-button type="primary" size="mini" icon="el-icon-search"
              >查询</el-button
            >
            <el-button type="primary" size="mini" icon="el-icon-delete"
              >重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 搜索end -->
      <el-table
        :data="tableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          min-width="80"
          label="标签名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="address"
          min-width="80"
          label="标签"
          align="center"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="标签说明" align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="创建用户"
          min-width="70px"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- <div class="pagination-box">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div> -->
    </div>
    <!-- 新增和修改弹出框 -->
    <el-dialog
      title="新增标签"
      :visible.sync="createDialog"
      width="600px"
      @open="noClick = false"
    >
      <el-form>
        <el-form-item label="标签名称" label-width="80px">
          <el-input placeholder="请输入标签名称"></el-input>
        </el-form-item>
        <el-form-item label="标签" label-width="80px">
          <el-input placeholder="请输入标签"></el-input>
        </el-form-item>
        <el-form-item label="标签说明" label-width="80px">
          <el-input placeholder="请输入标签说明"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary">确 定</el-button>
        <el-button @click="createDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
// import $ from "jquery";
export default {
  components: {
    Menu,
    LeftSideBar,
  },
  data() {
    return {
      current: "dept",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
      createDialog: false,
    };
  },
  methods: {
    // 显示新增弹框
    newTag() {
      this.createDialog = true;
    },
    deletePre() {},
  },
};
</script>

<style>
</style>